<template>
  <ReleaseNotePage :release="release" />
</template>

<script setup>
import { releasesBySlug } from '~/data/release-notes';

const route = useRoute();
const release = computed(() => releasesBySlug[route.params.slug]);

if (!release.value) {
  throw createError({ statusCode: 404, statusMessage: 'Release notes not found' });
}
</script>
